<template>
  <div class="shop-betslip-wrapper">
    <div class="betslip-text">
      <localized-label>betslipLabel</localized-label>
    </div>
    <div ref="ticketBets"
         class="ticket-bets-wrapper">
      <div class="bet"
           v-for="(item, index) in items"
           :key="index"
           :class="{ 'edit-bet': editIndex === index }">
        <div class="bet-info-text"
             @click="editBet(index)">
          <div class="values">
            {{item.displayValue}}
          </div>
          <div class="name">{{item.title}}</div>
          <div class="event">
            <div>
              <localized-label>eventLabel</localized-label>
              :
            </div>
            <div>{{item.event}}</div>
          </div>
          <div class="odds">
            <div>
              <localized-label>betOdds</localized-label>
              :
            </div>
            <div>{{item.odds}}</div>
          </div>
        </div>
        <div class="buttons">
          <div class="remove"
               @click="$emit('remove', index)">
            <i class="n-i n-i-close-a"></i>
          </div>
          <div class="stake">
            <div>
              <localized-label>stakeLabel</localized-label>
            </div>
            <div>
              <input v-model="bets[index].payment"
                     :maxlength="10"
                     class="stake-value"
                     @keypress="validateInput"
                     @focus="$event.target.select()"
                     @keypress.enter="focusPaymentInput(index)"
                     @keyup="editStake(index)"
                     @paste.prevent>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="betting-info-wrapper">
      <div class="betting-info">
        <div class="total">
          <input type="text"
                 ref="payment"
                 v-model="totalStake"
                 :disabled="disabled"
                 :maxlength="10"
                 @focus.stop="$event.target.select()"
                 @keyup="input"
                 @keypress="validateInput"
                 @keypress.enter="payin"
                 @paste.prevent>
        </div>
        <div class="pay-in">
          <button :disabled="disabled"
                  @click="$emit('payin')">
            <localized-label>payInLabel</localized-label>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  name: 'ShopBetslip',
  props: {
    disabled: {
      type: Boolean,
    },
    edit: {
      type: Boolean,
    },
    items: {
      type: Array,
    },
    total: {
      type: String,
    },
  },
  data() {
    return {
      bets: [],
      editIndex: null,
      tempIndex: null,
      totalStake: this.total,
    };
  },
  watch: {
    items(update) {
      this.bets = cloneDeep(update);
    },
    total(update) {
      this.totalStake = this.formatInput(update);
    },
    edit(update) {
      if (!update) {
        this.editIndex = update;
        this.tempIndex = null;
      }
    },
  },
  updated() {
    this.scrollToEnd();
  },
  methods: {
    editBet(index) {
      this.editIndex = this.tempIndex !== index ? index : false;
      this.$emit('editBet', this.editIndex);
      this.tempIndex = index;
    },
    editStake(index) {
      const payment = this.formatInput(this.bets[index].payment);
      if (this.isPaymentValid(payment)) {
        this.$emit('editStake', {
          index,
          stake: payment,
        });
      }
    },
    input(e) {
      if (e.keyCode === 188) {
        if (!this.totalStake.includes('.')) this.totalStake = this.totalStake.replace(/.$/, '.');
      }
      this.totalStake = this.formatInput(this.totalStake);
      if (this.isPaymentValid(this.totalStake)) {
        this.$emit('input', this.totalStake);
      }
    },
    payin() {
      this.$emit('input', this.totalStake);
      this.$nextTick(() => { this.$emit('payin'); });
    },
    validateInput(e) {
      const key = e.key.replace(',', '.');
      const keyIndex = e.target.selectionStart;
      const input = `${e.target.value.slice(0, keyIndex)}${key}${e.target.value.slice(keyIndex)}`;
      const isInputValid = input.match(/^([,\d]+)?\d+(?:\.\d{0,2})?$/g);
      if (!isInputValid) {
        e.preventDefault();
      }
    },
    formatInput(value) {
      return value.replace(/,/g, '').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    },
    isPaymentValid(value) {
      return value.slice(-1) !== '.';
    },
    scrollToEnd() {
      const el = this.$refs.ticketBets;
      el.scrollTop = el.scrollHeight;
    },
    focusPaymentInput() {
      this.$nextTick(() => {
        const paymentInput = this.$refs.payment;
        if (paymentInput) {
          paymentInput.focus();
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/mixins/scrollbar";
.shop-betslip-wrapper {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 29%;
  height: 100%;
  background-color: #2e3743;
  top: 0;
  right: 0;
  margin-top: 35px;
  .betslip-text {
    display: flex;
    align-items: center;
    height: 5%;
    padding-left: 13px;
    font-size: 14px;
    font-weight: 300;
    color: #ffffff;
    border-bottom: solid 1px #15181d;
  }
  .ticket-bets-wrapper {
    display: flex;
    flex-direction: column;
    height: 85%;
    width: 100%;
    overflow: auto;
    @include scrollbar(8px, #2e3743, #6b7585);
    .bet {
      display: flex;
      .bet-info-text {
        width: 80%;
        padding: 10px;
        border: solid 1px #4f5c6c;
        cursor: pointer;
        &:first-child {
          border-top: none;
        }
        .values {
          display: flex;
          flex-flow: wrap;
          font-size: 14px;
          font-weight: 900;
          color: #ffffff;
        }
        .name {
          font-size: 14px;
          color: #6c727a;
          margin-top: 3px;
        }
        .event, .odds {
          display: flex;
          font-size: 14px;
          color: #6c727a;
          margin-top: 3px;
          div {
            &:nth-child(2) {
            padding-left: 5px;
            }
          }
        }
      }
      .buttons {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 20%;
        .remove, .stake {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
        }
        .remove {
          .n-i {
            font-size: 20px;
            color: #4f5c6c;
            cursor: pointer;
          }
           &:hover {
             .n-i {
               color: #0FAF9F;
            }
          }
        }
        .stake {
          display: flex;
          flex-direction: column;
          border: solid 1px #ffffff;
          background-color: #ffffff;
          color: #2e3743;
          div {
            &:first-child {
              display: flex;
              align-items: flex-end;
              justify-content: center;
              font-size: 12px;
              width: 100%;
              height: 50%;
            }
            &:nth-child(2) {
              font-size: 14px;
              font-weight: bold;
              height: 50%;
              input {
                width: 100%;
                text-align: center;
                &:focus {
                  outline: none;
                }
              }
            }
          }
        }
      }
      &:hover {
        background:#252A31;
        .stake,
        .stake-value {
          background-color:#252A31;
          color: #ffffff;
          border-color:#6c727a;
        }
      }
    }
  }
  .betting-info-wrapper {
    display: flex;
    padding: 10px 16px 50px 16px;
    box-shadow: 0 -0.5rem 1.6rem -0.5rem rgba(0, 0, 0, 0.75);
    .betting-info {
      display: flex;
      height: 32px;
      width: 100%;
      .total {
        display: flex;
        align-items: center;
        width: 75%;
        color: #495057;
        background-color: #fff;
        font-size: 16px;
        font-weight: 900;
        ::selection {
          color: #ffffff;
          background-color: #136be6;
        }
        input {
          height: 100%;
          width: 100%;
          padding-left: 10px;
          &:focus {
            outline: none;
          }
        }
      }
      .pay-in {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 25%;
        color: #fff;
        background-color: #155ABB;
        font-size: 14px;
        button {
          width: 100%;
          height: 100%;
          &:focus {
            outline: none;
          }
        }
      }
    }
  }
  .edit-bet {
    background: #252A31;
    .buttons {
      .stake {
        border-color:#6c727a !important;

        div,
        .stake-value {
          background:#252A31;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
